import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { HeroSection } from '../components/home/HeroSection'
import { WelcomeSection } from '../components/home/WelcomeSection'
import { AmenitiesStrip } from '../components/home/AmenitiesStrip'
import { RoomsPreview } from '../components/home/RoomsPreview'
import { RestaurantPreview } from '../components/home/RestaurantPreview'
import { Testimonials } from '../components/home/Testimonials'
import { CtaSection } from '../components/home/CtaSection'
import { LocationMap } from '../components/home/LocationMap'
import { SITE_NAME } from '@/lib/constants'

export function HomePage() {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{SITE_NAME}</title>
        <meta name="description" content={t('welcome.description') as string} />
        <meta property="og:title" content={SITE_NAME} />
        <meta property="og:image" content="/images/nuva/hero/hero-habitaciones-page.jpeg" />
      </Helmet>

      {/* 1. Hero — full viewport, parallax bg, single CTA */}
      <HeroSection />

      {/* 2. About / Welcome */}
      <WelcomeSection />

      {/* 3. Rooms preview grid */}
      <RoomsPreview />

      {/* 4. Services / amenities */}
      <AmenitiesStrip />

      {/* 5. Activities preview (RestaurantPreview doubles as activities/services highlight) */}
      <RestaurantPreview />

      {/* 6. Testimonials */}
      <Testimonials />

      {/* 7. Final CTA */}
      <CtaSection />

      {/* 8. Map */}
      <LocationMap />
    </>
  )
}
